/**
 * Created by Ivan on 24.05.2025
 */

const KeyLockTutorial = function () {
    return new TutorialScenario(KeyLockTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(KeyLockTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(KeyLockTutorial.NAME);
            Game.currentGame.hand.setCards(KeyLockTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(KeyLockTutorial.NAME)
    });
};

KeyLockTutorial.NAME = "keyLock";
KeyLockTutorial.CONFIG = {
    handValues: ["q"],
    force: "KeyLockTutorialMessage"
};
